/* eslint-disable semi */
import React from 'react';
import PropTypes from 'prop-types';
import { H1, H2, H3, H4, H5, H6, Paragraph } from 'components/core/Typography';
import { Group } from 'components/core/Page';
import { MarkdownContent } from 'components/core/MarkdownContent';
import Link from 'components/core/Link/Link';

const markdownComponentMap = {
	h1: (props) => (
		<H1
			className="sf-type-large"
			{...props}
		/>
	),
	h2: (props) => (
		<H2
			className="sf-type-large"
			{...props}
		/>
	),
	h3: (props) => (
		<H3
			className="sf-type-medium"
			{...props}
		/>
	),
	h4: (props) => (
		<H4
			className="sf-type-medium"
			{...props}
		/>
	),
	h5: (props) => (
		<H5
			className="sf-type-small"
			{...props}
		/>
	),
	h6: (props) => (
		<H6
			className="sf-type-small"
			{...props}
		/>
	),
	p: (props) => <Paragraph {...props} />,
	a: ({ href = '', ...rest }) => {
		const isAnchorLink = href.startsWith('#');
		const relTokens = [];

		if (!isAnchorLink) {
			relTokens.push('noopener', 'noreferrer');
			if (!href.includes('sparefoot.com')) {
				relTokens.push('unfollow');
			}
		}

		return (
			<Link
				href={href}
				{...rest}
				target={isAnchorLink ? '_self' : '_blank'}
				{...(relTokens.length ? { rel: relTokens.join(' ') } : {})}
			/>
		);
	},
};
export default function MarkdownWrapper({ content, components, ...args }) {
	const mergedComponents = { ...markdownComponentMap, ...components };

	return (
		<div className="search-boilerplate">
			{content &&
				content.map((item, index) => {
					const value = item?.value || item;
					const key = value ? `${value} ${index}` : index;

					return (
						<Group key={key}>
							<MarkdownContent
								components={mergedComponents}
								content={value}
								{...args}
							/>
						</Group>
					);
				})}
		</div>
	);
}

MarkdownWrapper.propTypes = {
	content: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.string),
		PropTypes.arrayOf(PropTypes.object),
	]),
	components: PropTypes.objectOf(PropTypes.Component),
};
